import api from '@/js/services/api';

export default {
    //a

    addSiteBans(applicant_id, client_id) {
        return api().post(`/master-admin/applicants/${applicant_id}/sites-bans/add`, {client_id} );
    },

    addTagToApplicant(user_id, tag_id) {
        return api().post(`/master-admin/tags/add-to-applicant`, {user_id, tag_id})
    },

    add_editApplicantsAttachments(applicant_id, file_id, payload) {
        return api().post(`/master-admin/applicants/${applicant_id}/attachment/${file_id}/edit-add`, payload)
    },

    addNewComment(applicant_id, comment, type) {
        return api().post(`/master-admin/applicants/${applicant_id}/comment/add`, {comment, type});
    },

    addNewTag(name) {
        return api().post(`/master-admin/tags/add`, {name})
    },


    //c
    createApplicant(form) {
        return api().post(`/applicant/create`, form)
    },

    //d
    deleteApplicantAttachment(id, file_id) {
        return api().delete(`/master-admin/applicants/${id}/attachments/${file_id}/delete`);
    },

    deleteComment(id) {
        return api().delete(`/master-admin/applicants/comment/${id}/delete`);
    },

    deleteUsersTag (user_id, tag_id) {
        return api().post(`/master-admin/tags/remove-from-applicant`,{user_id, tag_id});
    },

    deleteApplicant(applicant_id) {
        return api().delete(`/master-admin/applicants/${applicant_id}/delete`);
    },

    //e

    exportUsersData(dataToSend) {
        return api().post('/master-admin/applicants/export', dataToSend, {responseType: 'blob'})
    },

    //g

    getApplicantsList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            if (value !== null && value !== undefined && value !== '') {
                if (typeof value === 'object' && !Array.isArray(value)) {
                    for (const [subKey, subValue] of Object.entries(value)) {
                        if (subValue.length > 0) {
                            subValue.forEach(item => {
                                searchParams.append(`${key}[${subKey}][]`, item);
                            });
                        }
                    }
                } else if (Array.isArray(value) && value.length > 0) {
                    value.forEach(item => {
                        searchParams.append(`${key}[]`, item);
                    });
                } else {
                    searchParams.append(key, value);
                }
            }
        }

        return api().get('/master-admin/applicants/get?' + searchParams.toString())
    },

    getFileInfo(id, formData) {
        return api().post(`/user/${id}/upload-file`, formData )
    },

    getUserInfo(id) {
        return api().get(`/master-admin/applicants/${id}/get`);
    },

    getApplicantsAttachments(id, filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/applicants/${id}/attachments/get?` + searchParams.toString())
    },

    getApplicantCallOut(applicant_id, filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/applicants/${applicant_id}/call-out/get?` + searchParams.toString())
    },

    getApplicantSiteBans(applicant_id, filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/applicants/${applicant_id}/sites-bans/get?` + searchParams.toString())
    },

    getApplicantStatusHistory(applicant_id, filters) {
        const searchParams = new URLSearchParams();
        for( const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get(`/master-admin/applicants/${applicant_id}/status/history/get?` + searchParams.toString())
    },

    // p

    getPrintData(applicant_id) {
        return api().get(`/master-admin/applicants/${applicant_id}/print`)
    },

   //s

    saveAddressData(id, form) {
        return api().put('/user/profile/address/' + id  + '/update', form)
    },

    saveAvailabilityData(id, form) {
        return api().put('/user/profile/availability/' + id + '/update', form)
    },

    saveEmergencyData(id,form) {
        return api().put('/user/profile/references/' + id + '/update', form)
    },

    saveLicenseData(id, form) {
        return api().put('/user/profile/positionAndLicenses/' + id + '/update', form)
    },

    sendEmailMessage(applicant_id, form) {
        return api().post(`/master-admin/settings/preconfigured-responses/applicant/${applicant_id}/send`, form)
    },

    setDateApplied(id) {
        return api().put(`/user/profile/dateApplied/${id}/update`)
    },
    //t
    transferNote(id) {
        return api().put(`/master-admin/applicants/comment/${id}/type/change` )
    },

    //u

    uploadPhoto(id, formData) {
        return api().post(`/master-admin/applicants/${id}/add-photo`, formData)
    },

    updateComment(comment_id, comment, type) {
        return api().put(`/master-admin/applicants/comment/${comment_id}/update`, {comment, type})
    },

    updateApplicantId (user_id, applicant_id) {
        return api().put(`/master-admin/applicants/${user_id}/personal-id/update`, {applicant_id})
    }

}
